import JimmysWebBanner from "../../assets/Jimmy's Web Banner.png";
import McpsWebBanner from "../../assets/McP's Web Banner.png";
import CaliforniaWildAlesWebBanner from "../../assets/California Wild Ales Web Banner.png";
import ChowCallWebBanner from "../../assets/Chow Call Web Banner.png";

export const SD_EVENTS = {
  chowCall: {
    key: "sd-chow-call-novo",
    slug: "chow-call",
    path: "/sd/chow-call",
    event_id: "sd26-chow-call-novo-2026-04-14",
    slot_id: "5b3b3d40-a34b-4aff-958a-d81476a39edc",
    title: "San Diego Chow Call",
    dateLabel: "Tuesday, April 14, 2026",
    timeLabel: "6-8 PM PT",
    venueName: "Novo Brazil Brewing Imperial Beach",
    addressLines: ["535 Florence St", "Imperial Beach, CA 91932"],
    webBanner: ChowCallWebBanner,
    mode: "family",
    limits: { maxPartySize: 2, capacityTotal: 26 },
    isClosed: true,
  },
  saluteSocialJimmys: {
    key: "sd-salute-social-jimmys",
    slug: "salute-social-jimmys",
    path: "/sd/salute-social-jimmys",
    event_id: "sd26-salute-social-jimmys-2026-04-15",
    slot_id: "3db677de-09e4-4dc2-9333-c3fb6eb5de9c",
    title: "San Diego Salute & Social",
    dateLabel: "Wednesday, April 15, 2026",
    timeLabel: "6-8 PM PT",
    venueName: "Jimmy's Famous American Tavern",
    addressLines: ["4990 N Harbor Dr", "San Diego, CA 92106"],
    webBanner: JimmysWebBanner,
    mode: "multi",
    limits: { maxAttendees: 6 },
    isClosed: true,
  },
  saluteSocialMcps: {
    key: "sd-salute-social-mcps",
    slug: "salute-social-mcps",
    path: "/sd/salute-social-mcps",
    event_id: "sd26-salute-social-mcps-2026-04-16",
    slot_id: "82d17fba-9a2a-4c10-ad57-a9fac6b263a0",
    title: "San Diego Salute & Social",
    dateLabel: "Thursday, April 16, 2026",
    timeLabel: "6-8 PM PT",
    venueName: "McP's Irish Pub & Grill",
    addressLines: ["1107 Orange Ave", "Coronado, CA 92118"],
    webBanner: McpsWebBanner,
    mode: "multi",
    limits: { maxAttendees: 6 },
  },
  saluteSocialCaliforniaWildAles: {
    key: "saluteSocialCaliforniaWildAles",
    slug: "salute-social-california-wild-ales",
    path: "/sd/salute-social-california-wild-ales",
    event_id: "sd26-salute-social-california-wild-ales-2026-04-17",
    slot_id: "feb20321-23d1-4b9f-90f3-f05d7c7d4b19",
    title: "San Diego Salute & Social",
    dateLabel: "Friday, April 17, 2026",
    timeLabel: "5-7 PM PT",
    venueName: "California Wild Ales",
    addressLines: ["4896 Newport Ave", "San Diego, CA 92107"],
    webBanner: CaliforniaWildAlesWebBanner,
    mode: "multi",
    limits: { maxAttendees: 50 },
  },
};
